import React, { useEffect, useState } from 'react';
import { useApiCaller } from '../utils/ApiUtilities';
import { useUser } from '../contexts/UserContext';
import { getMeUrl, getResendVerificationUrl } from '../utils/UrlUtilities';

// Persistent nudge for logged-in users whose email isn't verified yet. Dismissible
// for the session; offers a resend. Reads email_verified from /auth/me on mount.
export default function EmailVerifyBanner() {
    const CallApi = useApiCaller();
    const { userState } = useUser();
    const [verified, setVerified] = useState(true); // assume ok until we learn otherwise
    const [dismissed, setDismissed] = useState(false);
    const [resent, setResent] = useState(false);

    useEffect(() => {
        if (!userState?.isLoggedIn) return;
        let cancelled = false;
        (async () => {
            const res = await CallApi({ url: getMeUrl(), method: 'GET', token: true });
            if (!cancelled && res.success) setVerified(Boolean(res.data?.email_verified));
        })();
        return () => { cancelled = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userState?.isLoggedIn]);

    if (!userState?.isLoggedIn || verified || dismissed) return null;

    const resend = async () => {
        const res = await CallApi({ url: getResendVerificationUrl(), method: 'POST', token: true });
        if (res.success) setResent(true);
    };

    return (
        <div className="alert alert-warning d-flex justify-content-between align-items-center mb-0 rounded-0" role="alert">
            <span>
                📧 Please verify your email to secure your account. Check your email Inbox/Spam folder.
                {resent && <span className="ms-2 fw-semibold">Verification email sent — check your inbox.</span>}
            </span>
            <span>
                {!resent && (
                    <button className="btn btn-sm btn-outline-dark me-2" onClick={resend}>Resend link</button>
                )}
                <button className="btn btn-sm btn-link text-dark" onClick={() => setDismissed(true)}>Dismiss</button>
            </span>
        </div>
    );
}
